<template>
  <div class="row h-100 w-100">
    <div class="col-6 my-auto text-center">
      <span class="percent">
        {{(100*soumis/total).toFixed(1)}} %</span><br />
      soumis
    </div>
    <div class="col-6 my-auto text-center">
      <span class="percent">
        {{(100*termine/total).toFixed(1)}} %</span><br />
      terminé
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],

  computed: {
    total() {
      return this.data.nondebute + this.data.dev +
        this.data.revision + this.data.soumis +
        this.data.eval + this.data.termine;
    },
    soumis() {
      return this.data.revision + this.data.soumis +
        this.data.eval + this.data.termine;
    },
    termine() {
      return this.data.termine;
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Righteous&display=swap');
span.percent {
  font-size: 40px;
  font-family: 'Righteous', cursive;
}
</style>
